import React from "react";
import { M2Layout, PageHero, SectionIndex, CTABand } from "../../components/machines2/Blocks";
import { Reveal } from "../../components/enterprise2/Reveal";
import { SubNav } from "../../components/enterprise2/SubNav";
import { APPROACH_SECTIONS } from "../../data/machines2";

export default function Machines2Approach() {
  return (
    <M2Layout active="approach" title="Approach | Crowther for Machines">
      <PageHero
        eyebrow="Approach"
        title="Machines that cannot fail quietly."
        sub="A chatbot that errs produces a bad paragraph. A machine that errs produces a bad day, or far worse. Everything about how Crowther builds machine intelligence follows from taking that difference seriously."
        testId="m2-approach-hero"
      />
      <SubNav items={APPROACH_SECTIONS.map((s) => ({ id: s.id, label: s.title }))} testId="m2-approach-subnav" />

      {APPROACH_SECTIONS.map((s, i) => (
        <Reveal as="section" key={s.id} id={s.id} className="e2-shell e2-section" data-testid={`m2-approach-${s.id}`}>
          <SectionIndex n={`0${i + 1}`} label={s.title} />
          <div className="e2-split">
            <div className="e2-split-title-col">
              <h2 className="e2-h-l">{s.title}</h2>
            </div>
            <div>
              <p className="e2-body e2-body-lg">{s.body}</p>
            </div>
          </div>
        </Reveal>
      ))}

      <CTABand line="Find out more about Crowther for machines." testId="m2-approach-cta" />
    </M2Layout>
  );
}
